
import env from '@/.env.json';
import { phraseDeclension } from '@/plugins/formatting';
import OrderListDeliveries from '~/components/catalog/orderList/Deliveries';
import OrderListItemWrapper from '~/components/catalog/orderList/Item/Wrapper';
import OrderListItem from '~/components/catalog/orderList/Item';

export default {
  name: 'OrderList',
  components: {OrderListItem, OrderListItemWrapper, OrderListDeliveries},
  props: {
    product: {
      type: Object,
      required: true,
    },
    deliveries: {
      type: Array,
      required: true,
    },
    loadingDelivery: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      wordVariants: ['бонус', 'бонусов', 'бонуса'],
      returnVariants: ['день', 'дней', 'дня'],
      isIconDisabled: env.DELIVERY_ICON_DISABLED || false,
    }
  },
  computed: {
    guarantees() {
      return this.product?.guarantees || []
    },
  },
  methods: {
    phraseDeclension,
  },
};
